import { Container, Col, Row } from "react-bootstrap";
import Footer from "../../components/Layout/Footer/Footer";
import "../../components/Layout/Jumbotron/JumbotronII";

const Partners = () => {
  return (
    <div>
      <Container className="JumboBGII" fluid>
        <div className="OverlayII">
          <Row>
            <Col className="text-center">
              <h1>PARTNERS</h1>
            </Col>
          </Row>
        </div>
      </Container>
      <Container>
        <Row>
          <Col md={4}></Col>
          <Col md={4}>
            <h3>Tamayo Sports Florida</h3>
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
};

export default Partners;
